import { Button } from '@creditornot/cb-button';
import { Modal } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onClose: () => void;
};

const CancelButton = styled(Button).attrs({
  variant: 'secondary',
  size: 'small',
})``;

const LeaveButton = styled(Button).attrs({
  variant: 'primary',
  size: 'small',
})``;

const Content = styled.div`
  margin-block: 32px;
  margin-inline: 22px;
`;

const UnsavedChangesModal = ({ isOpen, onClose, onCancel }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      open={isOpen}
      onDismiss={onCancel}
      title={formatMessage({ id: 'self-serve-sign-up.onboarding-page.unsaved-changes.title' })}
      sizePreset="centered:medium"
      ContentComponent={() => (
        <Content>{formatMessage({ id: 'self-serve-sign-up.onboarding-page.unsaved-changes.description' })}</Content>
      )}
      footer={
        <>
          <CancelButton onClick={onCancel}>
            <FormattedMessage id="state.cancel" />
          </CancelButton>

          <LeaveButton onClick={onClose}>
            {formatMessage({ id: 'self-serve-sign-up.onboarding-page.unsaved-changes.leave' })}
          </LeaveButton>
        </>
      }
      footerStyle={{ justifyContent: 'flex-end', gap: 16 }}
    ></Modal>
  );
};

export default UnsavedChangesModal;
